import * as THREE from "three";

// Vanity GLBs ship with NO materials and are each a single mesh, so unlike the
// kitchen (which matches meshes by name and clones existing materials) we simply
// assign a fresh MeshStandardMaterial carrying the chosen finish texture to every
// mesh in the given scene. `part` is just for future per-part tuning if needed.
export function applyFinish(scene, texture, overrides = {}) {
  if (!scene) return;

  const [rx, ry] = overrides.repeat ?? [1, 1];

  scene.traverse((child) => {
    if (!child.isMesh) return;
    // clone per mesh so we never mutate the texture cached by useTexture
    const t = texture.clone();
    t.colorSpace = THREE.SRGBColorSpace;
    t.wrapS = THREE.RepeatWrapping;
    t.wrapT = THREE.RepeatWrapping;
    t.repeat.set(rx, ry);
    t.needsUpdate = true;
    child.material = new THREE.MeshStandardMaterial({
      map: t,
      roughness: overrides.roughness ?? 1.0,
      metalness: overrides.metalness ?? 0.0,
      envMapIntensity: overrides.envMapIntensity ?? 1.0,
    });
    child.material.needsUpdate = true;
  });
}
